import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const IpCamera = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.25293 21.2884V16.8942C9.25293 15.2367 10.5966 13.893 12.2542 13.893V13.893C13.9117 13.893 15.2554 15.2367 15.2554 16.8942V21.2884"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.2895 17.3941C12.3038 17.4084 12.3081 17.4299 12.3003 17.4486C12.2926 17.4673 12.2744 17.4795 12.2541 17.4795C12.2339 17.4795 12.2157 17.4673 12.2079 17.4487C12.2002 17.43 12.2044 17.4084 12.2187 17.3941V17.3941C12.2382 17.3746 12.2699 17.3746 12.2894 17.3941"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.2563 9.89133H6.25125C4.59371 9.89133 3.25 8.54763 3.25 6.89008V5.88967C3.25 4.78464 4.1458 3.88883 5.25083 3.88883H19.2567C20.3617 3.88883 21.2575 4.78464 21.2575 5.88967V6.89008C21.2575 8.54763 19.9138 9.89133 18.2563 9.89133Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.1066 9.76128C21.1329 13.1201 20.4261 17.4526 17.4373 19.9933C14.4486 22.534 10.0588 22.534 7.07007 19.9933C4.0813 17.4526 3.37451 13.1201 5.40085 9.76128"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </SVGIconRender>
  );
};

export default IpCamera;
